<section id="main" class="bg-light">
     <div id="billingSummaryReportContainer" class="container">
          <h1 [innerHtml]="'BillingSummaryReport' | translator:'invoice'">Billing Summary Report</h1>

          <div class="overlay" *ngIf="isDownloading">
               <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading...</h1>
               <img [alt]="'Loading' | translator:'base'" name="Loading" />
          </div>

          <div class="row">
               <div class="col-lg-8">
                    <div class="row gx-2">
                         <div class="col-12 mb-3">
                              <p [innerHtml]="'BillingSummaryTxt' | translator:'invoice'">
                                   This report provides a detailed listing of all associated charges that have been
                                   incurred during the selected billing cycle.<br><i>Note: If the billing cycle
                                        requested has not yet closed, the report is not final and may be missing
                                        charges. The report will reflect the following message: "Summary not final -
                                        Please check back later"</i>.
                              </p>
                         </div>
                         <div class="col-12 mb-3">
                              <div *ngIf="showReportDownloadedAlert"
                                   [ngClass]="'alert alert-success alert-dismissible fade ' + (showReportDownloadedAlert ? 'show' :'hide')"
                                   name="showReportDownloadedAlert"
                                   role="alert"
                              >
                                   <slot name="body">
                                        <span [innerHtml]="'reportDownloadedAlertBody' | translator:'invoice'">
                                             The selected report has been downloaded to your browser.
                                        </span>
                                   </slot>
                                   <button type="button"
                                           class="btn-close"
                                           data-dismiss="alert"
                                           (click)="showReportDownloadedAlert=false"
                                           [ariaLabel]="'Close' | translator:'base'"
                                           [title]="'Close' | translator:'base'"
                                   >
                                        <span class="visually-hidden">X</span>
                                   </button>
                              </div>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="billingPeriod" class="form-label">
                                   <span [innerHtml]="'billingPeriod' | translator:'invoice'">
                                        Billing Period (mm/yyyy)
                                   </span>:
                                   <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <select class="form-select"
                                      name="billingPeriod"
                                      id="billingPeriod"
                                      [(ngModel)]="billingPeriod"
                              >
                                   <option 
                                        *ngFor="let p of periodList; let index = index"
                                        [value]="p"
                                   >
                                        {{ p.substring(0,2) }}/{{ p.substring(2, 6) }}
                                        <span *ngIf="index === 0" [innerHtml]="'notFinal' | translator:'invoice'"> - NOT FINAL</span>
                                   </option>
                              </select>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="loginEmail" class="form-label" [innerHtml]="'loginEmailLabel' | translator:'invoice'">
                                   Login Email
                              </label>
                              <input type="text"
                                     class="form-control"
                                     name="loginEmail"
                                     id="loginEmail"
                                     [(ngModel)]="loginEmail"
                                     [placeholder]="'loginEmail' | translator:'invoice'" 
                              />
                         </div>
                         <div class="col-12 mb-3">
                              <label for="reportType" class="form-label" [innerHtml]="'outputFormat' | translator:'invoice'">
                                   Output Format: (This report is only available in PDF format):
                              </label>
                              <div class="form-check">
                                   <input class="form-check-input"
                                          type="radio"
                                          id="reportTypePdf"
                                          name="reportType"
                                          value="PDF"
                                          [(ngModel)]="reportType">
                                   <label class="form-check-label"
                                          [innerHtml]="'PDFReportType' | translator:'invoice'"
                                          for="reportTypePdf">PDF Document</label>
                              </div>
                              <div class="form-check">
                                   <input class="form-check-input"
                                          type="radio"
                                          id="reportTypeCsv"
                                          name="reportType"
                                          value="CSV"
                                          [(ngModel)]="reportType">
                                   <label class="form-check-label"
                                          [innerHtml]="'CSVReportType' | translator:'invoice'"
                                          for="reportTypeCsv">CSV File</label>
                              </div>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="reportLevel"
                                     class="form-label">
                                   <span [innerHtml]="'reportLevel' | translator:'invoice'">Level</span>:
                                   <span class="text-danger text-center ms-1"
                                         [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <select class="form-select"
                                      name="reportLevel"
                                      id="reportLevel"
                                      [(ngModel)]="reportLevel">
                                   <option value="Yes" 
                                        selected
                                        [innerHtml]="'withTransactionMemo' | translator:'invoice'"
                                   >
                                        With TRANSACTION MEMO
                                   </option>
                                   <option 
                                        value="No"
                                        [innerHtml]="'withoutTransactionMemo' | translator:'invoice'"
                                   >
                                        Without TRANSACTION MEMO
                                   </option>
                              </select>
                         </div>
                         <div class="col-6 mb-3">
                              <button class="btn btn-primary btn-strong"
                                      [innerHtml]="'downloadReport' | translator:'invoice'"
                                      [title]="'downloadReport' | translator:'invoice'"
                                      (click)="downloadReport()"
                                      [disabled]="!pageValid()"
                                      id="downloadReport"
                                      name="downloadReport">
                                   Request Report
                              </button>
                         </div>
                         <div class="col-6 mb-3">
                              <button [innerHtml]="'returnBillingReports' | translator:'invoice'"
                                      [title]="'returnBillingReports' | translator:'invoice'"
                                      routerLink="/billingReports"
                                      class="btn btn-secondary btn-strong">
                                   Return to Billing Reports
                              </button>
                         </div>
                    </div>
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <app-dashboardsupport></app-dashboardsupport>
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0"
                                  [innerHtml]="'Resources' | translator:'base'">Resources
                              </h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button (click)="openDocument('PSPMotorCarrierEnrollment')"
                                                target="_blank"
                                                class="btn btn-link"
                                                [title]="'MAHEnrollAgreement' | translator:'base'"
                                                [innerHtml]="'MAHEnrollAgreement' | translator:'base'"
                                                name="MAHagreement"
                                                id="MAHagreement">PSP Monthly Account Holder Enrollment Agreement
                                        </button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button (click)="openDocument('ISPAccountHolderAgreement')"
                                                target="_blank"
                                                class="btn btn-link"
                                                [innerHtml]="'ISPEnrollAgreement' | translator:'base'"
                                                [title]="'ISPEnrollAgreement' | translator:'base'"
                                                name="ISPagreement"
                                                id="ISPagreement">PSP Industry Service Provider Enrollment Agreement
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                                [innerHtml]="'DisclosureAndAuth' | translator:'base'"
                                                (click)="openDocument('PSPDisclosureandAuthorizationForm')"
                                                target="_blank"
                                                [title]="'DisclosureAndAuth' | translator:'base'"
                                                name="dna"
                                                id="dna">Disclosure
                                             and Authorization Form
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                             (click)="openDocument('BillingGuide')"
                                             target="_blank"
                                             name="billingmanual"
                                             id="billingmanual"
                                             [title]="'billingManual' | translator:'payment'"
                                             [innerHTML]="'billingManual' | translator:'payment'"
                                        >
                                             Billing Manual
                                        </button>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>